/**
 * The dayIndex represent an offset in days
 * eg: 0 is today, 1 is tomorrow, 2 is the day after tomorrow...
 */
export default dayIndex => dayIndex === 0;
